import { z } from 'zod/v4-mini'

const fromTo = z.nullable(z.optional(z.iso.date()))

export const searchParamsToFromSchema = z.object({
    from: fromTo,
    to: fromTo,
})
